export const STATUS_NEEDS_MORE_INFORMATION = 'needs_more_information';

export const STATUS_PENDING_REAPPROVAL = 'pending_reapproval';
